import type { DashboardData, DashboardRange } from '@c214/shared';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { apiGet } from '../lib/api';
import { useAuth } from './useAuth';

const REFRESH_MS = 5 * 60_000;

export function useAdminDashboard(range: DashboardRange) {
  const { data: user } = useAuth();
  return useQuery({
    queryKey: ['admin', 'dashboard', range] as const,
    queryFn: () => apiGet<DashboardData>(`/api/admin/dashboard?range=${range}`),
    enabled: user?.role === 'admin',
    refetchInterval: REFRESH_MS,
    placeholderData: keepPreviousData,
  });
}
